import { Stack, Typography } from "@mui/material";
import { AlertCircle } from "@surya-digital/leo-reactjs-material-ui";
import { observer } from "mobx-react";
import React from "react";
import { CheckIcon } from "lucide-react";
import { ValidateRespondentSPoCMappingErrors } from "../../store/RespondentSPoCMappingStore";
import { ICON_SIZE, getIconProps } from "@pulse/shared-components";
import {
  FoundationColorTokens,
  Spacing,
  Typography as LeoTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { TFunction } from "i18next";
import { Instance } from "mobx-state-tree";
import { RespondentSPoCMappingStore } from "../../store/RespondentSPoCMappingStore";

interface RespondentSPoCAssignmentValidationResultProps {
  t: TFunction;
  spacing: Spacing;
  tokens: FoundationColorTokens<string>;
  typography: LeoTypography;
  respondentSPoCMappingStore: Instance<
    typeof RespondentSPoCMappingStore
  > | null;
}

export const RespondentSPoCAssignmentValidationResult = observer(
  ({
    respondentSPoCMappingStore,
    spacing,
    t,
    tokens,
    typography,
  }: RespondentSPoCAssignmentValidationResultProps): React.ReactElement => {
    let validationResultDialogDescription: string;
    let validationResultDialogDescriptionColor: string;
    let validationResultDialogIcon: JSX.Element;

    if (respondentSPoCMappingStore?.rpcErrors) {
      validationResultDialogIcon = (
        <AlertCircle {...getIconProps(tokens.iconError, ICON_SIZE.large)} />
      );
      validationResultDialogDescriptionColor = tokens.labelError;
      switch (respondentSPoCMappingStore.rpcErrors) {
        case ValidateRespondentSPoCMappingErrors.InvalidFile: {
          validationResultDialogDescription = t(
            "projects.respondentList.spocAssignmentInvalidFileErrorDescription",
          );
          break;
        }
        case ValidateRespondentSPoCMappingErrors.UnknownFile: {
          validationResultDialogDescription = t(
            "projects.respondentList.spocAssignmentUnknownFileErrorDescription",
          );
          break;
        }
        case ValidateRespondentSPoCMappingErrors.SpocAssignmentInProgress: {
          validationResultDialogDescription = t(
            "projects.respondentList.spocAssignmentInProgressDescription",
          );
          break;
        }
        case ValidateRespondentSPoCMappingErrors.ProjectArchived: {
          validationResultDialogDescription = t(
            "projects.respondentList.spocAssignmentProjectArchivedDescription",
          );
          break;
        }
        default: {
          validationResultDialogDescription = t(
            "common.uploadDialog.unexpectedErrorDescription",
          );
          break;
        }
      }
    } else {
      validationResultDialogDescription = t(
        "projects.respondentList.spocAssignmentSuccessDescription",
      );
      validationResultDialogDescriptionColor = tokens.labelSuccess;
      validationResultDialogIcon = (
        <CheckIcon {...getIconProps(tokens.iconSuccess, ICON_SIZE.large)} />
      );
    }

    return (
      <Stack
        alignItems="center"
        spacing={spacing.spaceXS}
        padding={spacing.spaceXL}
        width="100%"
        textAlign="center"
      >
        {validationResultDialogIcon}
        <Typography
          sx={{
            ...typography.b1,
            color: validationResultDialogDescriptionColor,
          }}
        >
          {validationResultDialogDescription}
        </Typography>
      </Stack>
    );
  },
);
